import React, { Fragment } from "react";
import ShowFormColumns from "../components/ShowFormColumns";
import logo from 'url:../images/logo.svg';
import { useNavigate  } from 'react-router-dom';

const IntroPage:React.FC = () => {

  const navigate = useNavigate();

  const begin = () => {
    navigate('/curriculum/subjects');
  }

  return (
    <div className='intropage'>
      <div className='intropage__wall'>
        <ShowFormColumns live={false} />
        <div className='intropage__wall_overlay'></div>
      </div>
      <div className='intropage__text'>
        <img src={logo} alt='Dollar Academy shield logo.' />
        <h1>The Dollar Academy Curriculum</h1>
        <p>
        We are proud to offer the widest range of academic subjects in Scotland, complimented by over 120 different co-curricular activities. With such a diverse offering, we are confident every child will find subjects and activities to inspire them.
        </p>
        <button onClick={begin}>Begin</button>
      </div>
    </div>
  )
}

export default IntroPage;
